/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable prettier/prettier */
import React from 'react';

import Layout from '@/components/Layout';
import { Container, Box, Text, Flex, Divider } from 'theme-ui';
import Halo from '@/components/Halo';
// import ThreeBox from '@/components/Three';
// import Shalom from '@/components/Shalom';
import Rings from '@/components/Rings';

interface CardBlockProps {
  title: string;
  desc: string;
  ph: number;
}

// color: string;
//   stemColor: string;
function CardBlock({ title, desc, ph }: CardBlockProps) {
  return (
    <Box sx={{ maxWidth: [`100%`, `100%`, `30%`], mr: 0, mb: [6, 3, 3] }}>
      <Box sx={{ mt: 3 }}>
        <Text sx={{ fontWeight: `500`, fontSize: `15px`, opacity: `0.2` }}>
          19:19
        </Text>
      </Box>
      <Box
        sx={{
          mb: 3,
          mt: 3,
          // bg: `grays.2`,
          width: [`100%`, `100%`, `30%`],
          height: 102,
          // border: `solid 1px`,
          borderColor: `grays.2`,
        }}
      >
        <Box sx={{ width: `100%` }}>
          <img
            alt="jebin"
            src={`../../location.png`}
            style={{
              maxWidth: [`100%`],
            }}
          />
        </Box>
      </Box>
      <Text
        as="h3"
        sx={{ fontSize: [3, 4, `23.44px`], mb: 2, fontWeight: `Bold` }}
      >
        {title}
      </Text>
      <Text
        as="p"
        sx={{
          fontSize: `18.75px`,
          mr: [0, 6, 6],
          color: `Stext`,
          fontWeight: `400`,
          mb: 2,
        }}
      >
        {desc}
      </Text>
      <Flex sx={{ gap: `10px`, mr: [0, 6, 6], alignItems: `center` }}>
        <Text
          as="p"
          sx={{
            fontSize: `18.75px`,
            color: `Stext`,
            fontWeight: `400`,
          }}
        >
          {ph}
        </Text>
        <img
          alt="jebin"
          src={`../../union.png`}
          style={{
            maxWidth: `12.33px`,
            maxHeight: `11.44px`,
          }}
        />
      </Flex>
    </Box>
  );
}

function IndexPage() {
  return (
    <Layout>
      <Halo
        title="Contact us"
        url=""
        image=""
        author=""
        description="Contact our product design agency for your product development or design needs"
      />
      <Box
        sx={{
          minHeight: [`70vh`, `73vh`, `73vh`],
          borderBottomColor: `grays.4`,
          maxWidth: [`90vw`, `80vw`, `93vw`],
          marginLeft: [`auto`, `auto`, `auto`],
          marginRight: [`0px`, `0px`, `0.1px`],
          px: [0, 4, 0],
          pt: [7, 0, 7],
          display: `flex`,
          alignItems: `center`,
          justifyContent: `space-between`,
          flexWrap: `wrap`,
          overflow: `hidden`,
        }}
      >
        <Box
          sx={{
            p: 0,
            m: 0,
            mt: -6,
            flex: [`0.7`, `0.5`, `0.5`],
          }}
        >
          <Text
            as="p"
            sx={{
              mb: [0, 4, 4],
              fontSize: `15px`,
              fontWeight: 400,
              color: `grays.8`,
            }}
          >
            Let’s talk?
          </Text>
          <Text
            as="p"
            sx={{ mb: 4, fontSize: 4, fontWeight: `bold`, mt: [3, 6, `0px`] }}
          >
            Tell us about your project and goals
          </Text>
          <Text
            as="p"
            variant="pageDesc"
            sx={{ mb: 4, fontSize: 1, fontWeight: 300, color: `grays.8` }}
          >
            We&apos;re excited to see your interest in partnering with us, leave
            us a message and we&apos;ll get back to you as soon as possible
          </Text>
          <Flex sx={{ gap: [`32px`] }}>
            <Text variant="talkButton">Schedule a call</Text>
            <Text
              variant="talkButtonAlter"
              sx={{ padding: [`30 !important`, `0px`, `0px`] }}
            >
              Send Enquiry
            </Text>
          </Flex>
        </Box>
        <Box
          sx={{
            flex: 0.7,
            overflow: `hidden`,
            height: `73vh`,
            position: [`absolute`, `relative`, `relative`],
            maxWidth: `89vw`,
            // '@media screen and (max-width: 720px)': {
            //   position: `absolute`,
            //   top: `-2vh`,
            // },
          }}
        >
          <Rings />
        </Box>
      </Box>
      <Container sx={{ p: [0, `auto`, `auto`] }}>
        <Box
          variant="styles.pageFrame"
          sx={{ paddingTop: `0px !important`, marginBottom: `0px !important` }}
        >
          <Flex sx={{ alignItems: `center`, justifyContent: `center` }}>
            <Divider
              sx={{
                flex: 1,
                color: `Dcolor`,
                '@media screen and (max-width: 720px)': {
                  display: `none`,
                },
              }}
            />
            <Box
              sx={{
                mb: 3,
                // bg: `grays.2`,
                height: [`auto`],
                // border: `solid 1px`,
                // backgroundColor: `grays.1`,
                paddingTop: `35px`,
              }}
            >
              <Flex
                sx={{
                  justifyContent: `space-between`,
                  alignItems: `center`,
                  gap: `20px`,
                }}
              >
                <Box sx={{ paddingLeft: `0px !important` }}>
                  <img
                    alt="jebin"
                    src={`../../jebin.png`}
                    style={{
                      maxWidth: [`40%`, `125px`, `165px`],
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    maxWidth: [`40%`, `380px`, `24vw`],
                    marginTop: [`10px`],
                  }}
                >
                  <Text
                    as="h2"
                    sx={{ color: `grays.8`, fontWeight: `700`, fontSize: 1 }}
                  >
                    Jebin Koshy
                  </Text>
                  <Text
                    as="p"
                    sx={{
                      fontSize: 0,
                      fontWeight: `400`,
                      color: `grays.6`,
                      mb: 2,
                    }}
                  >
                    Operations
                  </Text>
                  <Text
                    as="p"
                    sx={{ fontSize: 0, fontWeight: `400`, color: `grays.6` }}
                  >
                    I would be glad to discuss your requirements and potential
                    business opportunities.
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Flex>

          <Box variant="styles.bodyFrame2" sx={{ py: 3, ml: 0, mt: 0 }}>
            {/* <Text as="h3" variant="blockTitle" sx={{ py: 2 }}>
              Our Team
            </Text> */}
            <Box>
              <Text as="h1" sx={{ fontWeight: `700`, fontSize: 3 }}>
                Our Offices
              </Text>
              <Box sx={{ pb: 0, pt: `0vh` }}>
                <Flex
                  sx={{
                    flexWrap: `wrap`,
                    flexDirection: [`column`, `row`, `row`],
                    justifyContent: `space-between`,
                  }}
                >
                  <CardBlock
                    title="Bengaluru"
                    desc="Caravel Building, 1st A Main Road, ST Bed, Koramangala 4th Block, Bengaluru, Karnataka 560095"
                    ph="+91 8050473500"
                  />
                  {/* <CardBlock
                    title="Doha"
                    desc="#389, Al Khafji Street,Duhail South 63084,Doha, Qatar"
                    ph="+91 8050473500"
                  />
                  <CardBlock
                    title="Kozhikode"
                    desc="#389, Al Khafji Street,Duhail South 63084,Doha, Qatar"
                    ph="+91 8050473500"
                  /> */}
                </Flex>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Layout>
  );
}

export default IndexPage;
